import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  title: {
    paddingBottom: 0,
  },
  contentText: {
    color: '#7C7C7C',
    fontSize: 15,
  },
  content: {
    paddingTop: 0,
  },
  actions: {
    padding: '8px 24px',
  },
  rotateIcon: {
    transform: 'rotate(180deg)',
  },
  closeIconBtn: {
    float: 'right',
  },
  aboutDonationsTitle: {
    fontSize: 14,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
  aboutDonationsText: {
    color: '#7C7C7C',
    fontSize: 12,
  },
}));
